import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "reduxStore/state";
import * as Yup from "yup";
import { updateLevel, createLevel } from "reduxStore/actions/levelActions";
import { searchLocations } from "reduxStore/actions/locationActions";
import { useEffect, useState } from "react";
import { debounce } from "lodash";

export const useLevelForm = ({ editMode, currentLevel, setOpen }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const organisationId = user.organisation;

  const locationSearchResults =
    useSelector((state) => state.locationSearchResults) || [];
  const [searchLocationTerm, setSearchLocationTerm] = useState("");

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Year Name is required"),
    locations: Yup.array()
      .min(1, "At least one location is required")
      .of(
        Yup.object().shape({
          _id: Yup.string().required("Location ID is required"),
          name: Yup.string().required("Location Name is required"),
        })
      ),
  });

  const initialValues = {
    name: currentLevel ? currentLevel.name : "",
    locations: currentLevel ? currentLevel.locations : [],
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    values.organisation = organisationId;
    try {
      let response;
      if (editMode) {
        response = await dispatch(updateLevel(currentLevel._id, values));
      } else {
        response = await dispatch(createLevel(values));
      }

      if (response) {
        dispatch(
          setSnackbar({
            open: true,
            message: editMode
              ? "Year updated successfully"
              : "Year created successfully",
            severity: "success",
          })
        );
      } else {
        dispatch(
          setSnackbar({
            open: true,
            message: "An error occurred. Please try again.",
            severity: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        setSnackbar({
          open: true,
          message: "An error occurred. Please try again.",
          severity: "error",
        })
      );
    } finally {
      setSubmitting(false);
      setOpen(false);
    }
  };

  // Debounce the search location function to reduce the number of API calls
  useEffect(() => {
    const debounceFetch = debounce(() => {
      if (searchLocationTerm) {
        dispatch(searchLocations(searchLocationTerm));
      }
    }, 300);
    debounceFetch();

    // cleanup function to cancel the debounce on unmount
    return () => {
      debounceFetch.cancel();
    };
  }, [searchLocationTerm, dispatch]);

  return {
    validationSchema,
    initialValues,
    handleSubmit,
    locationSearchResults,
    setSearchLocationTerm,
  };
};
